import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { AuthService } from '../../../../../../services/auth.services'
import { RestServices } from '../../../../../../services/rest.services'
import { ModalService } from '../../../../../../services/modal.service'
import { SharedServices } from '../../../../../../services/shared.services'
import { ClientTopServices } from '../../../../../../services/ClientTop.services'
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms'
import { getImageRedirectUrl } from '../../../../../../../helper/common'
import { MatrixServices } from '../../../../../../services/image/matrix.services'
import { StateServices } from '../../../../../../services/state.services'
import * as $ from 'jquery'


@Component({
    selector: 'app-modal-client-detail-top-registraion-dental',
    templateUrl: './modal-client-detail-registraion-dental.component.html',
    styleUrls: [
        '../../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../../stagingcss/ui-schema-table-form.component.css',
        '../../../../../../stagingcss/main-body.component.css',
        '../../../../../../stagingcss/lui-select.component.css',
        './modal-client-detail-registraion-dental.component.css',
        '../../../../../../stagingcss/image-viewer.component.css',
    ],
})
export class ModalClientDetailRegistraionDentalComponent implements OnInit, OnDestroy {
    en = {}
    showEN = true
    option_RegistrationXray = 'active'
    TabRegistrationXrayClass
    status: Boolean = false
    arrRegistrationDental: any[] = []

    arrTabRegistrationDental = [
        { id: 0, name: 'All', nameSave: 'Registration-All' },
        { id: 1, name: '1', nameSave: 'Registration-Tooth-Front-Right' },
        { id: 2, name: '2', nameSave: 'Registration-Tooth-Front-Front' },
        { id: 3, name: '3', nameSave: 'Registration-Tooth-Side-Left' },
        { id: 4, name: '4', nameSave: 'Registration-Tooth-Side-Upper' },
        { id: 5, name: '5', nameSave: 'Registration-Tooth-Overjet' },
        { id: 6, name: '6', nameSave: 'Registration-Tooth-Lower' },
        { id: 7, name: '7', nameSave: 'Registration-Tooth-Front-Right' },
        { id: 8, name: '8', nameSave: 'Registration-Tooth-Front-Front' },
        { id: 9, name: '9', nameSave: 'Registration-Tooth-Side-Left' },
        { id: 10, name: '10', nameSave: 'Registration-Tooth-Side-Upper' },
        { id: 11, name: '11', nameSave: 'Registration-Tooth-Overjet' },
        { id: 12, name: '12', nameSave: 'Registration-Tooth-Lower' },
        { id: 13, name: '13', nameSave: 'Registration-Tooth-Front-Right' },
        { id: 14, name: '14', nameSave: 'Registration-Tooth-Front-Front' },
        { id: 15, name: '15', nameSave: 'Registration-Tooth-Side-Left' },
        { id: 16, name: '16', nameSave: 'Registration-Tooth-Side-Upper' },
        { id: 17, name: '17', nameSave: 'Registration-Tooth-Overjet' },
        { id: 18, name: '18', nameSave: 'Registration-Tooth-Lower' },
    ]
    option_Registration: String = 'active'
    senMax: any = 100
    max: any = 0
    statusImage: String = ''
    arrStyleImage = []
    arrAllXray: any[] = []
    jsonXray: any = {}
    arrShowStatus: any[] = []
    index: any
    tabName: any = 'dental-all'
    uploadImageForm: FormGroup
    width: any
    height: any
    imageAddHeight: any
    imageAddWidth: any
    valChange: any = 0

    matrixImage: any[] = []
    arrImage: any[] = []
    emitTabName: any = {}
    emitArrAll: any = {}
    animationDuration: any
    arrLoading: any[] = []
    arrStyle: any[] = [{}, {}, {}, {}, {}, {}]
    isEmptyArray: Boolean = false
    resourceUrl = 'resource'
    countRecrond
    tabUploadImage: any
    ValueAssignOneDistance: any = 0
    @ViewChild('imageWrapper') imageWrapper: ElementRef
    @ViewChild('imageId') imageId: ElementRef
    oldHeight: any
    oldWidth: any

    defaultArrayTypeImage: any[] = ['large', 'large', 'large', 'large', 'large', 'large',
        'large', 'large', 'large', 'large', 'large', 'large',
        'large', 'large', 'large', 'large', 'large', 'large']
    arrayTypeImage: any[] = ['large', 'large', 'large', 'large', 'large', 'large',
        'large', 'large', 'large', 'large', 'large', 'large',
        'large', 'large', 'large', 'large', 'large', 'large']
    arrIds: any[] = []

    unscrCopy
    unscrIndex
    unscrAllArrClientTop
    unscrArrHash

    getInfoIndex = undefined
    page = 'registration'
    unscrPage

    constructor(private _sharedService: SharedServices,
        private authData: AuthService,
        private restApi: RestServices,
        private formBuider: FormBuilder,
        private modalService: ModalService,
        private clientTopServices: ClientTopServices,
        public matrixServices: MatrixServices,
        private stateServices: StateServices) {
        this.option_RegistrationXray = 'active'
        this.TabRegistrationXrayClass = 'option_0'
    }

    ngOnInit() {
        //this.resetMatrix()
        this.arrLoading = [true, true, true, true, true, true]
        this.uploadImageForm = this.formBuider.group({
            requests: new FormArray([
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),

                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),

                // new FormControl(null),
                // new FormControl(null),
                // new FormControl(null),
                // new FormControl(null),
                // new FormControl(null),
                // new FormControl(null),
            ]),
        })
        // this.clientTopServices.changeEmittedTabName$.subscribe(infoTabName => {
        const infoTabName: any = this.clientTopServices.functReturnTabName()
        if (infoTabName != null && infoTabName['tabName'] != undefined) {
            this.tabName = infoTabName['tabName']
        } else {
            this.tabName = 'dental-all'
        }
        const tmpStr: String = this.tabName
        if (tmpStr.includes('dental')) {
            this.getArrClientTop()
        }
        // });

        this.clientTopServices.changeEmittedStatus$.subscribe(res => {
            if (res != null && res['status'] != undefined) {
                this.status = res['status']
            } else {
                this.status = false
            }
        })
        if ($(window).innerWidth() != window.screen.width) {
            this.width = ($(window).innerWidth() - 300) / 6
            this.height = 2 * this.width / 3
        } else if ($(window).innerHeight() != window.screen.height) {
            const tmpH = $(window).innerHeight()
            this.width = ($(window).innerWidth() - 300) / 6
            this.height = 2 * this.width / 3
        }
        this.oldHeight = this.height
        this.oldWidth = this.width
        this.imageAddHeight = this.height / 6
        this.imageAddWidth = this.width / 6
        this.getArrHash()
        this.getStyle()
        this.resizeUser()
        this.resizeFullScreen()
        this.getPage()
    }

    ngOnDestroy() {
        this.getInfoIndex = undefined
        this.unscrPage.unsubscribe()
        this.unscrIndex.unsubscribe()
        this.unscrAllArrClientTop.unsubscribe()
        this.unscrArrHash.unsubscribe()
    }

    getPage() {
        this.unscrPage = this.clientTopServices.changeEmiitedPage$.subscribe(res => {
            if (res) {
                this.page = res
            }
        })
    }

    resizeFullScreen() {
        this.clientTopServices.changeEmitted$.subscribe(screen => {
            if (screen != null && screen != undefined && screen['status'] != undefined) {
                if (screen['status'] == 'active') {
                    this.height = this.oldHeight
                    this.width = this.oldWidth
                } else if (screen['status'] == 'hidden') {
                    if ($(window).innerWidth() != window.screen.width) {
                        const tmpW = $(window).innerWidth()
                        this.width = (tmpW - 300) / 6
                        this.height = this.width * 2 / 3
                    } else if ($(window).innerHeight() != window.screen.height) {
                        const tmpH = $(window).innerHeight()
                        this.width = ($(window).innerWidth() - 300) / 6
                        this.height = 2 * this.width / 3
                    }
                }
                const _thi = this
                setTimeout(function () {
                    _thi.arrShowStatus.forEach((el, item) => {
                        if (el) {
                            const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                            const imageId: HTMLElement = document.getElementById('imageId' + item)
                            _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, _thi.matrixImage, _thi.arrImage, _thi.arrRegistrationDental)
                        }
                    })
                }, 10)
            }
        })
    }

    resetMatrix() {
        this.matrixServices.arrRotate = [0, 0, 0, 0, 0, 0,0, 0, 0, 0, 0, 0]
        this.matrixServices.arrStyleImage = [0, 0, 0, 0, 0, 0,0, 0, 0, 0, 0, 0]
        this.matrixServices.arrFlip = [
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
        ]
    }

    resizeUser() {
        this.clientTopServices.changeEmittedViewDetailUser$.subscribe(status => {
            const tmpStr: String = this.tabName
            if (tmpStr.includes('dental')) {
                if (status != null && status['status'] != undefined) {
                    this.resetMatrix()
                    const tmp: any = status['status']
                    if (tmp == 'in') {
                        if ($(window).innerWidth() != window.screen.width) {
                            const tmpW = $(window).innerWidth()
                            this.width = (tmpW - 300) / 6
                            this.height = this.width * 2 / 3
                        } else if ($(window).innerHeight() != window.screen.height) {
                            const tmpH = $(window).innerHeight()
                            this.height = (tmpH - 500) / 2
                            this.width = this.height * 3 / 2
                        } else {
                            const tmpH = $(window).innerHeight()
                            this.height = (tmpH - 500) / 2
                            this.width = this.height * 3 / 2
                        }
                    } else {
                        if ($(window).innerWidth() != window.screen.width) {
                            const tmpW = $(window).innerWidth()
                            this.width = (tmpW - 300) / 6
                            this.height = this.width * 2 / 3
                        } else if ($(window).innerHeight() != window.screen.height) {
                            const tmpH = $(window).innerHeight()
                            this.height = (tmpH - 300) / 2
                            this.width = this.height * 3 / 2
                        }
                    }
                    this.oldHeight = this.height
                    this.oldWidth = this.width
                    const _thi = this
                    setTimeout(function () {
                        _thi.arrShowStatus.forEach((el, item) => {
                            if (el) {
                                const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                                const imageId: HTMLElement = document.getElementById('imageId' + item)
                                _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, _thi.matrixImage, _thi.arrImage, _thi.arrRegistrationDental)
                            }
                        })
                    }, 10)
                }
            }
        })
    }

    resetMatrixMovedUpPage() {
        const _thi = this
        setTimeout(function () {
            _thi.arrShowStatus.forEach((el, item) => {
                if (el) {
                    const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                    const imageId: HTMLElement = document.getElementById('imageId' + item)
                    if (imageId != undefined && imageWrapper != undefined) {
                        _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, _thi.matrixImage, _thi.arrImage, _thi.arrRegistrationDental)
                    }
                }
            })
        }, 10)
    }

    getArrClientTop() {
        this.getDataShow()
        this.getDataIndex()
    }

    getDataIndex() {
        this.unscrIndex = this.clientTopServices.changeEmittedIndex$.subscribe(infoIndex => {
            const tmpStr: String = this.tabName
            if (infoIndex != null && infoIndex['index'] != undefined && this.page == 'registration') {
                this.index = infoIndex['index']
                this.getInfoIndex = jQuery.extend(true, {}, infoIndex)
                if (tmpStr.includes('dental') && this.arrAllXray.length > 0) {
                    // const arrAll: any = this.clientTopServices.returnArrAll();
                    this.max = this.arrAllXray.length - 1
                    if (this.max > 0) {
                        this.ValueAssignOneDistance = this.senMax / this.max
                        this.valChange = this.index * this.ValueAssignOneDistance
                    } else {
                        this.valChange = 0
                    }
                    this.arrLoading = [false, false, false, false, false, false]
                    if (this.arrAllXray[this.index] != undefined) {
                        this.jsonXray = this.arrAllXray[this.index]

                        this.initJsonXray(this.arrAllXray[this.index])
                        this.animationDuration = 300
                    }
                }
            }
        })
    }

    getDataShow() {
        this.unscrAllArrClientTop = this.clientTopServices.changeEmittedAllArrClientTo$.subscribe(arrAll => {
            const tmpStr: String = this.tabName
            if (arrAll != null && arrAll['registration'] != undefined && arrAll['registration'].length > 0 && this.page == 'registration') {
                this.isEmptyArray = false
                this.arrAllXray = arrAll['registration']
                this.countRecrond = arrAll['registration'].length
                if (tmpStr.includes('dental') && this.getInfoIndex) {
                    if (this.arrAllXray.length > 0) {
                        this.max = this.arrAllXray.length - 1
                        if (this.max > 0) {
                            this.ValueAssignOneDistance = this.senMax / this.max
                            this.valChange = this.index * this.ValueAssignOneDistance
                        } else {
                            this.valChange = 0
                        }
                        if (this.arrAllXray[this.index] != undefined) {
                            this.jsonXray = this.arrAllXray[this.index]
                            this.initJsonXray(this.arrAllXray[this.index])
                            this.animationDuration = 300
                        }
                    }
                }
            } else {
                this.countRecrond = 0
                this.isEmptyArray = true
                this.arrRegistrationDental = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' },
                { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' },
                { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
                this.getShowStatus(this.arrRegistrationDental)
            }
        })
    }

    // isEmptyArr() {
    //   this.clientTopServices.changeEmiitedIsCreated$.subscribe(create => {
    //     if (create != null && create['create'] != undefined) {
    //       const tab: any = create['tabName'];

    //       if (tab == this.tabName) {
    //         this.isEmptyArray = true;
    //         this.getArrClientTop();
    //       }
    //     }
    //   });
    // }

    // refresh() {
    //   this.clientTopServices.changeEmittedrefreshArr$.subscribe(refresh => {
    //     if (refresh != null && refresh['refresh'] != undefined) {
    //       const tab: any = refresh['tabName'];
    //       if (refresh['refresh'] == true && this.tabName == tab) {
    //         this.callApiInfoTopClient();
    //       }
    //     }
    //   });
    // }

    getArrCopy() {
        this.unscrCopy = this.clientTopServices.changeEmittedArrCopy$.subscribe(arCopy => {
            if (arCopy != null && arCopy['onCut'] != undefined) {
                if (arCopy['onCut'] == 'cut') {
                    const tab = arCopy['tabName']
                    if (this.tabName == tab) {
                        this.arrRegistrationDental = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' },{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
                        this.getShowStatus(this.arrRegistrationDental)
                        this.jsonXray[this.tabName] = this.arrRegistrationDental
                        this.arrAllXray[this.index] = this.jsonXray
                        const arrCopy: any[] = arCopy['arrCopy']
                        const tmp: any = arrCopy[0]['id'] ? arrCopy[0]['id'] : ''
                        const jsonTmp: any = {}
                        jsonTmp['id'] = tmp
                        if (arrCopy[0]['id'] != '') {
                            switch (this.tabName) {
                                case 'dental-1':
                                    if (tmp != '') {
                                        this.jsonXray['dental-all'][0] = jsonTmp
                                    }
                                    break
                                case 'dental-2':
                                    if (tmp != '') {
                                        this.jsonXray['dental-all'][1] = jsonTmp
                                    }
                                    break
                                case 'dental-3':
                                    if (tmp != '') {
                                        this.jsonXray['dental-all'][2] = jsonTmp
                                    }
                                    break
                                case 'dental-4':
                                    if (tmp != '') {
                                        this.jsonXray['dental-all'][3] = jsonTmp
                                    }
                                    break
                                case 'dental-5':
                                    if (tmp != '') {
                                        this.jsonXray['dental-all'][4] = jsonTmp
                                    }
                                    break
                                case 'dental-6':
                                    if (tmp != '') {
                                        this.jsonXray['dental-all'][5] = jsonTmp
                                    }
                                    break
                                    case 'dental-7':
                                        if (tmp != '') {
                                            this.jsonXray['dental-all'][6] = jsonTmp
                                        }
                                        break
                                    case 'dental-8':
                                        if (tmp != '') {
                                            this.jsonXray['dental-all'][7] = jsonTmp
                                        }
                                    break
                                    case 'dental-9':
                                        if (tmp != '') {
                                            this.jsonXray['dental-all'][8] = jsonTmp
                                        }
                                    break
                                    case 'dental-10':
                                        if (tmp != '') {
                                            this.jsonXray['dental-all'][9] = jsonTmp
                                        }
                                    break
                                    case 'dental-11':
                                        if (tmp != '') {
                                            this.jsonXray['dental-all'][10] = jsonTmp
                                        }
                                    break
                                    case 'dental-12':
                                        if (tmp != '') {
                                            this.jsonXray['dental-all'][11] = jsonTmp
                                        }
                                    break
                                case 'dental-all':
                                    arrCopy.forEach((el, i) => {
                                        switch (i) {
                                            case 0:
                                                this.jsonXray['dental-1'][0] = jsonTmp
                                                break
                                            case 1:
                                                this.jsonXray['dental-2'][0] = jsonTmp
                                                break
                                            case 2:
                                                this.jsonXray['dental-3'][0] = jsonTmp
                                                break
                                            case 3:
                                                this.jsonXray['dental-4'][0] = jsonTmp
                                                break
                                            case 4:
                                                this.jsonXray['dental-5'][0] = jsonTmp
                                                break
                                            case 5:
                                                this.jsonXray['dental-6'][0] = jsonTmp
                                                break
                                                case 6:
                                                this.jsonXray['dental-6'][0] = jsonTmp
                                                break
                                                case 7:
                                                this.jsonXray['dental-7'][0] = jsonTmp
                                                break
                                                case 8:
                                                this.jsonXray['dental-8'][0] = jsonTmp
                                                break
                                                case 9:
                                                this.jsonXray['dental-9'][0] = jsonTmp
                                                break
                                                case 10:
                                                this.jsonXray['dental-10'][0] = jsonTmp
                                                break
                                                case 11:
                                                this.jsonXray['dental-11'][0] = jsonTmp
                                                break
                                            default:
                                                break
                                        }
                                    })
                                    break
                                default:
                                    break
                            }
                            this.arrAllXray[this.index] = this.jsonXray
                        }
                    }
                }
            }
        })
    }

    getStyle() {
        this.clientTopServices.changeEmittedStyle$.subscribe(style => {
            if (style != null && style['style'] != undefined) {
                const tab: any = style['tabName']
                if (tab == this.tabName) {
                    this.arrStyle = style['style']
                    if (this.arrStyle.length > 0) {
                        this.arrRegistrationDental = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' },
                        { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' },
                        { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }
                        ]
                        this.getShowStatus(this.arrRegistrationDental)
                        this.jsonXray[this.tabName] = this.arrRegistrationDental
                        this.arrAllXray[this.index] = this.jsonXray
                        this.emitArrAll['registration'] = this.arrAllXray
                        this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
                    } else {
                        const arrCopy: any[] = style['arrCopy']
                        this.arrRegistrationDental = arrCopy
                        this.getShowStatus(this.arrRegistrationDental)
                        this.jsonXray[this.tabName] = this.arrRegistrationDental
                        this.arrAllXray[this.index] = this.jsonXray
                    }
                }
            } else {
                this.arrStyle = [{}, {}, {}, {}, {}, {},{}, {}, {}, {}, {}, {}]
            }
        })
    }

    getArrHash() {
        this.unscrArrHash = this.stateServices.changeEmittedHash$.subscribe(response => {
            if (response != null && response[this.tabName] != undefined && response[this.tabName].length > 0) {
                const tmpStr: String = this.tabName
                const arrRes: any[] = response[this.tabName]
                if (tmpStr.includes('dental')) {
                    this.arrRegistrationDental = jQuery.extend(true, [], arrRes)
                    // arrRes.forEach((el, i) => {
                    //     this.arrRegistrationDental[i] = el;
                    // });
                    this.jsonXray[this.tabName] = this.arrRegistrationDental
                    this.arrAllXray[this.index] = this.jsonXray
                    const tmp: any = arrRes[0]
                    switch (this.tabName) {
                        case 'dental-1':
                            this.arrAllXray[this.index]['dental-all'][0] = tmp
                            break
                        case 'dental-2':
                            this.arrAllXray[this.index]['dental-all'][1] = tmp
                            break
                        case 'dental-3':
                            this.arrAllXray[this.index]['dental-all'][2] = tmp
                            break
                        case 'dental-4':
                            this.arrAllXray[this.index]['dental-all'][3] = tmp
                            break
                        case 'dental-5':
                            this.arrAllXray[this.index]['dental-all'][4] = tmp
                            break
                        case 'dental-6':
                            this.arrAllXray[this.index]['dental-all'][5] = tmp
                            break

                            case 'dental-7':
                            this.arrAllXray[this.index]['dental-all'][6] = tmp
                            break
                        case 'dental-8':
                            this.arrAllXray[this.index]['dental-all'][7] = tmp
                            break
                        case 'dental-9':
                            this.arrAllXray[this.index]['dental-all'][8] = tmp
                            break
                        case 'dental-10':
                            this.arrAllXray[this.index]['dental-all'][9] = tmp
                            break
                        case 'dental-11':
                            this.arrAllXray[this.index]['dental-all'][10] = tmp
                            break
                        case 'dental-12':
                            this.arrAllXray[this.index]['dental-all'][11] = tmp
                            break
                        case 'dental-all':
                            arrRes.forEach((el, i) => {
                                const count = i + 1
                                const tabN = 'dental-' + count
                                this.arrAllXray[this.index][tabN][0] = el
                            })
                            break
                        default:
                            break
                    }
                    this.emitArrAll['registration'] = this.arrAllXray
                    this.emitArrAll['checkChange'] = true
                    this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
                }
            }
        })
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        if (event.target.innerWidth != window.screen.width) {
            const tmpW = event.target.innerWidth
            this.width = (tmpW - 300) / 6
            this.height = this.width * 2 / 3
        } else if (event.target.innerHeight != window.screen.height) {
            const tmpW = event.target.innerWidth
            this.width = (tmpW - 300) / 6
            this.height = this.width * 2 / 3
        }
        this.oldHeight = this.height
        this.oldWidth = this.width
    }

    // getValueSlider() {
    //   this.clientTopServices.changeEmittedValueSlider$.subscribe(res => {
    //     if (res != null && res['sliderClientTop'] != undefined) {
    //       this.valChange = res['sliderClientTop'];
    //     }
    //   });
    // }

    changeValueEx1SliderRegister(valueUsageChange) {
        const value: any = valueUsageChange
        if (this.max > 0) {
            const tmp: number = (value / this.senMax) * this.max
            this.index = Math.round(tmp)
            const tmpEarch: number = this.senMax / this.max
            const assignCalculate = Math.round(tmpEarch)
            const assign = this.index * assignCalculate
            // if (this.arrAllXray[this.index] != undefined) {
            //     this.jsonXray = this.arrAllXray[this.index];
            //     this.initJsonXray(this.jsonXray);
            //     this.arrRegistrationDental = this.jsonXray[this.tabName];
            // }
            // this.valChange = assign;
            const valueSlider: any = {}
            valueSlider['sliderClientTop'] = valueUsageChange
            this.clientTopServices.emitChangeSlider(valueSlider)
        } else {
            this.valChange = 0
            const valueSlider: any = {}
            valueSlider['sliderClientTop'] = 0
            this.clientTopServices.emitChangeSlider(valueSlider)
        }
    }

    initJsonXray(json) {
        this.jsonXray['face-1'] = (json['face-1'] != undefined) ? json['face-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['face-2'] = (json['face-2'] != undefined) ? json['face-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['face-3'] = (json['face-3'] != undefined) ? json['face-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['face-4'] = (json['face-4'] != undefined) ? json['face-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['face-5'] = (json['face-5'] != undefined) ? json['face-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['face-6'] = (json['face-6'] != undefined) ? json['face-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['face-all'] = (json['face-all'] != undefined) ? json['face-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonXray['other-1'] = (json['other-1'] != undefined) ? json['other-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['other-2'] = (json['other-2'] != undefined) ? json['other-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['other-3'] = (json['other-3'] != undefined) ? json['other-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['other-4'] = (json['other-4'] != undefined) ? json['other-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['other-5'] = (json['other-5'] != undefined) ? json['other-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['other-6'] = (json['other-6'] != undefined) ? json['other-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['other-all'] = (json['other-all'] != undefined) ? json['other-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonXray['movie-1'] = (json['movie-1'] != undefined) ? json['movie-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['movie-2'] = (json['movie-2'] != undefined) ? json['movie-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['movie-3'] = (json['movie-3'] != undefined) ? json['movie-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['movie-4'] = (json['movie-4'] != undefined) ? json['movie-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['movie-5'] = (json['movie-5'] != undefined) ? json['movie-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['movie-6'] = (json['movie-6'] != undefined) ? json['movie-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['movie-all'] = (json['movie-all'] != undefined) ? json['movie-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonXray['xp-1'] = (json['xp-1'] != undefined) ? json['xp-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['xp-2'] = (json['xp-2'] != undefined) ? json['xp-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['xp-3'] = (json['xp-3'] != undefined) ? json['xp-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['xp-4'] = (json['xp-4'] != undefined) ? json['xp-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['xp-5'] = (json['xp-5'] != undefined) ? json['xp-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['xp-6'] = (json['xp-6'] != undefined) ? json['xp-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['xp-all'] = (json['xp-all'] != undefined) ? json['xp-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonXray['tooth-right'] = (json['tooth-right'] != undefined) ? json['tooth-right'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['tooth-front'] = (json['tooth-front'] != undefined) ? json['tooth-front'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['tooth-left'] = (json['tooth-left'] != undefined) ? json['tooth-left'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['tooth-upper'] = (json['tooth-upper'] != undefined) ? json['tooth-upper'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['tooth-overjet'] = (json['tooth-overjet'] != undefined) ? json['tooth-overjet'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['tooth-lower'] = (json['tooth-lower'] != undefined) ? json['tooth-lower'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['tooth-all'] = (json['tooth-all'] != undefined) ? json['tooth-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonXray['aligner-right'] = (json['aligner-right'] != undefined) ? json['aligner-right'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['aligner-front'] = (json['aligner-front'] != undefined) ? json['aligner-front'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['aligner-left'] = (json['aligner-left'] != undefined) ? json['aligner-left'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['aligner-upper'] = (json['aligner-upper'] != undefined) ? json['aligner-upper'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['aligner-overjet'] = (json['aligner-overjet'] != undefined) ? json['aligner-overjet'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['aligner-lower'] = (json['aligner-lower'] != undefined) ? json['aligner-lower'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonXray['aligner-all'] = (json['aligner-all'] != undefined) ? json['aligner-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.genDentalJson(json, 18);

        this.jsonXray['dental-all'] = (json['dental-all'] != undefined) ? json['dental-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' },
        { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' },
        { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        if (this.jsonXray['dental-all'].length < 18) {
            for (let i = this.jsonXray['dental-all'].length; i < 18; i++) {
                this.jsonXray['dental-all'][i] = { id: '' }
            }
        }

        this.arrayTypeImage = jQuery.extend(true, [], this.defaultArrayTypeImage)
        this.getArrRegistrationXray(this.jsonXray)
    }

    genDentalJson(json, maxCount) {
        for (let i = 0; i < 18; i++) {
            this.jsonXray['dental-' + (i + 1)] = (json['dental-6' + (i + 1)] != undefined) ? json['dental-' + (i + 1)] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        }
    }
    getArrRegistrationXray(arrXray) {
        this.arrRegistrationDental = arrXray[this.tabName]

        this.getShowStatus(this.arrRegistrationDental)
    }

    swapMatrix(index, nextIndex) {
        const tmp = this.matrixImage[index]
        const swapTmp = this.matrixImage[nextIndex]
        this.matrixImage[index] = swapTmp
        this.matrixImage[nextIndex] = tmp
    }

    swapArrImage(index, nextIndex) {
        const tmp = this.arrImage[index]
        const swapTmp = this.arrImage[nextIndex]
        this.arrImage[index] = swapTmp
        this.arrImage[nextIndex] = tmp
    }

    swapArrImageStyle(index, nextIndex) {
        const tmp = this.arrStyleImage[index]
        const swapTmp = this.arrStyleImage[nextIndex]
        this.arrStyleImage[index] = swapTmp
        this.arrStyleImage[nextIndex] = tmp
    }

    swapArr(index, nextIndex) {
        this.swapMatrix(index, nextIndex)
        this.swapArrImage(index, nextIndex)
        this.swapArrImageStyle(index, nextIndex)
        const tmp = this.arrRegistrationDental[index]
        const tmpRight = this.arrRegistrationDental[nextIndex]
        this.arrRegistrationDental[index] = tmpRight
        this.arrRegistrationDental[nextIndex] = tmp
        switch (this.TabRegistrationXrayClass) {
            case 'option_0':
                this.jsonXray['dental-all'] = this.arrRegistrationDental
                let i: any
                let left: any
                let right: any
                const countIndex = index + 1
                switch (countIndex) {
                    case 1:
                        i = 'dental-1'
                        right = 'dental-2'
                        break
                    case 2:
                        left = 'dental-1'
                        i = 'dental-2'
                        right = 'dental-3'
                        break
                    case 3:
                        left = 'dental-2'
                        i = 'dental-3'
                        right = 'dental-4'
                        break
                    case 4:
                        left = 'dental-3'
                        i = 'dental-4'
                        right = 'dental-5'
                        break
                    case 5:
                        left = 'dental-4'
                        i = 'dental-5'
                        right = 'dental-6'
                        break
                    case 6:
                        left = 'dental-5'
                        i = 'dental-6'
                        right = 'dental-7'
                        break

                    case 7:
                        left = 'dental-6'
                        i = 'dental-7'
                        right = 'dental-8'
                        break
                    case 8:
                        left = 'dental-7'
                        i = 'dental-8'
                        right = 'dental-9'
                        break
                    case 9:
                        left = 'dental-8'
                        i = 'dental-9'
                        right = 'dental-10'
                        break
                    case 10:
                        left = 'dental-9'
                        i = 'dental-10'
                        right = 'dental-11'
                        break
                    case 11:
                        left = 'dental-10'
                        i = 'dental-11'
                        right = 'dental-12'
                        break
                    case 12:
                        left = 'dental-11'
                        i = 'dental-12'
                        right = 'dental-13'
                        break
                }
                if (index > nextIndex) {
                    this.jsonXray[left][0] = tmp
                    this.jsonXray[i][0] = tmpRight
                } else {
                    this.jsonXray[i][0] = tmpRight
                    this.jsonXray[right][0] = tmp
                }
                break
            case 'option_1':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonXray['dental-all'][0] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonXray['dental-all'][0] = tmp3
                }
                this.jsonXray['dental-1'] = this.arrRegistrationDental
                break
            case 'option_2':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonXray['dental-all'][1] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonXray['dental-all'][1] = tmp3
                }
                this.jsonXray['dental-2'] = this.arrRegistrationDental
                break
            case 'option_3':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonXray['dental-all'][2] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonXray['dental-all'][2] = tmp3
                }
                this.jsonXray['dental-3'] = this.arrRegistrationDental
                break
            case 'option_4':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonXray['dental-all'][3] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonXray['dental-all'][3] = tmp3
                }
                this.jsonXray['dental-4'] = this.arrRegistrationDental
                break
            case 'option_5':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonXray['dental-all'][4] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonXray['dental-all'][4] = tmp3
                }
                this.jsonXray['dental-5'] = this.arrRegistrationDental
                break
            case 'option_6':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonXray['dental-all'][5] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonXray['dental-all'][5] = tmp3
                }
                this.jsonXray['dental-6'] = this.arrRegistrationDental
                break

                case 'option_7':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonXray['dental-all'][6] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonXray['dental-all'][6] = tmp3
                }
                this.jsonXray['dental-7'] = this.arrRegistrationDental
                break

                case 'option_8':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonXray['dental-all'][7] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonXray['dental-all'][7] = tmp3
                }
                this.jsonXray['dental-8'] = this.arrRegistrationDental
                break

                case 'option_9':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonXray['dental-all'][8] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonXray['dental-all'][8] = tmp3
                }
                this.jsonXray['dental-9'] = this.arrRegistrationDental
                break
                case 'option_10':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonXray['dental-all'][9] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonXray['dental-all'][9] = tmp3
                }
                this.jsonXray['dental-10'] = this.arrRegistrationDental
                break

                case 'option_11':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonXray['dental-all'][10] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonXray['dental-all'][10] = tmp3
                }
                this.jsonXray['dental-11'] = this.arrRegistrationDental
                break

                case 'option_12':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonXray['dental-all'][11] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonXray['dental-all'][11] = tmp3
                }
                this.jsonXray['dental-12'] = this.arrRegistrationDental
                break                
            default:
                break
        }
        this.arrAllXray[this.index] = this.jsonXray
        this.emitArrAll['registration'] = this.arrAllXray
        this.emitArrAll['checkChange'] = true
        this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
        this.getShowStatus(this.arrRegistrationDental)
    }

    moveRight(index) {
        const nextIndex: any = index + 1
        this.swapArr(index, nextIndex)
    }

    moveLeft(index) {
        const nextIndex: any = index - 1
        this.swapArr(index, nextIndex)
    }

    onDeleteImage(index) {
        this.matrixServices.removePhoto(index)
        const tmpNone: any = {}
        tmpNone['id'] = ''
        this.arrRegistrationDental[index] = tmpNone
        switch (this.TabRegistrationXrayClass) {
            case 'option_0':
                this.jsonXray['dental-all'] = this.arrRegistrationDental
                const indexNow = index + 1
                const i: any = 'dental-' + indexNow
                const tmp: any = {}
                tmp['id'] = ''
                this.jsonXray[i][0] = tmp
                break
            case 'option_1':
                if (index == 0) {
                    const tmp1: any = {}
                    tmp1['id'] = ''
                    this.jsonXray['dental-all'][0] = tmp1
                }
                this.jsonXray['dental-1'] = this.arrRegistrationDental
                break
            case 'option_2':
                if (index == 0) {
                    const tmp2: any = {}
                    tmp2['id'] = ''
                    this.jsonXray['dental-all'][1] = tmp2
                }
                this.jsonXray['dental-2'] = this.arrRegistrationDental
                break
            case 'option_3':
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonXray['dental-all'][2] = tmp3
                }
                this.jsonXray['dental-3'] = this.arrRegistrationDental
                break
            case 'option_4':
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonXray['dental-all'][3] = tmp3
                }
                this.jsonXray['dental-4'] = this.arrRegistrationDental
                break
            case 'option_5':
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonXray['dental-all'][4] = tmp3
                }
                this.jsonXray['dental-5'] = this.arrRegistrationDental
                break
            case 'option_6':
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonXray['dental-all'][5] = tmp3
                }
                this.jsonXray['dental-6'] = this.arrRegistrationDental
                break

                case 'option_7':
                    if (index == 0) {
                        const tmp3: any = {}
                        tmp3['id'] = ''
                        this.jsonXray['dental-all'][6] = tmp3
                    }
                    this.jsonXray['dental-7'] = this.arrRegistrationDental
                    break
                    case 'option_8':
                        if (index == 0) {
                            const tmp3: any = {}
                            tmp3['id'] = ''
                            this.jsonXray['dental-all'][7] = tmp3
                        }
                        this.jsonXray['dental-8'] = this.arrRegistrationDental
                        break

                        case 'option_9':
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonXray['dental-all'][8] = tmp3
                }
                this.jsonXray['dental-9'] = this.arrRegistrationDental
                break

                case 'option_10':
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonXray['dental-all'][9] = tmp3
                }
                this.jsonXray['dental-10'] = this.arrRegistrationDental
                break

                case 'option_11':
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonXray['dental-all'][10] = tmp3
                }
                this.jsonXray['dental-11'] = this.arrRegistrationDental
                break
            default:
                break
        }
        this.uploadImageForm.reset()
        this.matrixServices.removePhoto(index)
        this.arrAllXray[this.index] = this.jsonXray
        this.emitArrAll['registration'] = this.arrAllXray
        this.emitArrAll['checkChange'] = true
        this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
        this.getShowStatus(this.arrRegistrationDental)
    }

    getShowStatus(arr: any[] = []) {
        this.arrShowStatus = []
        this.matrixImage = []
        this.arrImage = []
        this.arrStyleImage = []
        if (arr && arr.length > 0) {
            arr.forEach((el, i) => {
                if (el != undefined && el['id'] != undefined && el['id'] != '') {
                    let url
                    if (this.arrayTypeImage[i] != 'other') {
                        url = getImageRedirectUrl(el['id'] + '?type=' + this.arrayTypeImage[i])
                    } else {
                        url = getImageRedirectUrl(el['id'])
                    }
                    this.arrIds[i] = el['id']
                    this.arrImage.push(url)
                    this.arrShowStatus.push(true)
                } else {
                    this.arrImage.push(undefined)
                    this.arrShowStatus.push(false)
                }
                if (el != undefined && el['matrix'] != undefined) {
                    this.matrixImage.push(el['matrix'])
                } else {
                    this.matrixImage.push([1, 0, 0, 1])
                }
                if (el != undefined && el['style'] != undefined) {
                    this.arrStyleImage.push(el['style'])
                } else {
                    this.arrStyleImage.push({})
                }
            })
            this.getStyleMatrix(this.matrixImage, this.arrImage, this.arrRegistrationDental)
        }
        // this.resetMatrixMovedUpPage();
    }

    getStyleMatrix(matrixImage, arrImage, arrRegistration) {
        const _thi = this
        setTimeout(() => {
            arrRegistration.forEach(function (el, item) {
                const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                const imageId: HTMLElement = document.getElementById('imageId' + item)
                _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, matrixImage, arrImage, arrRegistration)
            })
        }, 200)
    }

    toggleTabRegistrationXrayItem(id, event) {
        this.uploadImageForm.reset()
        this.TabRegistrationXrayClass = id
        switch (id) {
            case 'option_0':
                this.tabName = 'dental-all'
                break
            case 'option_1':
                this.tabName = 'dental-1'
                break
            case 'option_2':
                this.tabName = 'dental-2'
                break
            case 'option_3':
                this.tabName = 'dental-3'
                break
            case 'option_4':
                this.tabName = 'dental-4'
                break
            case 'option_5':
                this.tabName = 'dental-5'
                break
            case 'option_6':
                this.tabName = 'dental-6'
                break

                case 'option_7':
                this.tabName = 'dental-7'
                break
            case 'option_8':
                this.tabName = 'dental-8'
                break
            case 'option_9':
                this.tabName = 'dental-9'
                break
            case 'option_10':
                this.tabName = 'dental-10'
                break
            case 'option_11':
                this.tabName = 'dental-11'
                break
            default:
                this.tabName = 'dental-all'
                break
        }
        this.arrayTypeImage = jQuery.extend(true, [], this.defaultArrayTypeImage)
        this.tabUploadImage = undefined
        this.emitTabName['tabName'] = this.tabName
        this.arrRegistrationDental = this.jsonXray[this.tabName]
        this.clientTopServices.emitChangeTabName(this.emitTabName)
        this.getShowStatus(this.arrRegistrationDental)
    }

    getUrlImage(item, url) {
        if (url == '') {
            if (undefined !== this.arrRegistrationDental && this.arrRegistrationDental.length > 0) {
                const tmp: any = this.arrRegistrationDental[item]
                if (tmp != undefined && tmp['id'] != '') {
                    return getImageRedirectUrl(tmp['id'])
                }
            }
            return ''
        } else {
            return url
        }
    }

    setArrClientTop(data, index, idImage: any = {}) {
        this.arrRegistrationDental = data
        this.getShowStatus(this.arrRegistrationDental)
        switch (this.tabUploadImage) {
            case 'option_0':
                this.jsonXray['dental-all'] = data
                const countIndex: any = index + 1
                const i: any = 'dental-' + countIndex
                this.jsonXray[i][0] = idImage
                break
            case 'option_1':
                this.setOptionData(data, index, idImage, 0)
                break
            case 'option_2':
                this.setOptionData(data, index, idImage, 1)
                break
            case 'option_3':
                this.setOptionData(data, index, idImage, 2)
                break
            case 'option_4':
                this.setOptionData(data, index, idImage, 3)
                break
            case 'option_5':
                this.setOptionData(data, index, idImage, 4)
                break
            case 'option_6':
                this.setOptionData(data, index, idImage, 5)
                break
            case 'option_7':
                this.setOptionData(data, index, idImage, 6)
                break
            case 'option_8':
                this.setOptionData(data, index, idImage, 7)
                break
            case 'option_9':
                this.setOptionData(data, index, idImage, 8)
                break
            case 'option_10':
                this.setOptionData(data, index, idImage, 9)
                break
            case 'option_11':
                this.setOptionData(data, index, idImage, 10)
                break
            case 'option_12':
                this.setOptionData(data, index, idImage, 11)
                break
            default:
                break
        }

        this.arrAllXray[this.index] = this.jsonXray
        this.emitArrAll['registration'] = this.arrAllXray
        this.emitArrAll['checkChange'] = true
        this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
    }
    setOptionData(data, index, idImage: any = {}, i) {
        if (index == 0) {
            const tmp3: any = idImage
            this.jsonXray['dental-all'][i] = tmp3
        }
        this.jsonXray[`dental-${i + 1}`] = data
    }
    uploadFileEnd(event) {
        this.tabUploadImage = this.TabRegistrationXrayClass
        this.clientTopServices.checkChangeData = true
        const jsonFlip: any = {
            'horizontalFlip': 1,
            'verticalFlip': 1,
        }

        const i = event.item
        this.matrixServices.arrFlip[i] = jsonFlip
        const tmp: any = {}
        tmp['id'] = event.success['hash']
        tmp['matrix'] = [1, 0, 0, 1]
        this.arrRegistrationDental[i] = tmp
        this.matrixImage[i] = [1, 0, 0, 1]
        const url = getImageRedirectUrl(event.success['hash'])
        this.arrImage[i] = url

        this.setArrClientTop(this.arrRegistrationDental, i, tmp)
        this.arrLoading[i] = false
    }

    onUploadError() {
        this.uploadImageForm.reset()
    }

    onStartUpload(event) {
        let listUpload: any[] = event.listUpload
        this.animationDuration = event.animationDuration
        const arrLenghtImageFile = event.arrLenghtImageFile
        for (let index = 0; index < listUpload.length; index++) {
            if (listUpload[index] && arrLenghtImageFile > index) {
                this.arrLoading[listUpload[index]] = true
            }
        }
    }

    handleFileInput(files: FileList, index, event) {

        if (event.target.files && event.target.files[0]) {
            this.tabUploadImage = this.TabRegistrationXrayClass
            const arrUploadImage: any[] = this.arrRegistrationDental
            const reader = new FileReader()
            reader.readAsDataURL(event.target.files[0])
            const excrptFile: any = 'image/'
            const tmpFile: any = files[0]
            const typeFile: String = tmpFile['type']
            if (typeFile.includes(excrptFile)) {
                this.animationDuration = 2800
                this.arrLoading[index] = true
                reader.onload = (event: any) => {
                    this.statusImage = 'option_' + index
                    this.arrShowStatus[index] = true
                    this.getUrlImage(0, event.target.result)
                }
                this.authData.authToken().then(tokenReNew => {
                    this.restApi.postFile(files.item(0), tokenReNew).subscribe(
                        success => {
                            const jsonFlip: any = {
                                'horizontalFlip': 1,
                                'verticalFlip': 1,
                            }
                            this.arrLoading[index] = false
                            this.matrixServices.arrFlip[index] = jsonFlip
                            const tmp: any = {}
                            tmp['id'] = success['hash']
                            tmp['matrix'] = [1, 0, 0, 1]
                            arrUploadImage[index] = tmp
                            this.matrixImage[index] = [1, 0, 0, 1]
                            const url = getImageRedirectUrl(success['hash'])
                            this.arrImage[index] = url

                            this.setArrClientTop(arrUploadImage, index, tmp)
                            this.resetFile(index)
                        },
                    )
                })
            } else {
                this.uploadImageForm.reset()
            }
        } else {
            this.uploadImageForm.reset()
        }
    }

    resetFile(item) {
        $('#fileUpload_' + item).val('');
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/top/registration/registrationDental/modal-client-detail-registraion-dental.component.ts